import { useState } from 'react';
import { BLOCK_GROUPS } from '../flowConstants';

function BlockGroups({ onDragStartPalette, onAddBlock, draggable }) {
  return BLOCK_GROUPS.map((group) => (
    <div key={group.title} className="mt-3">
      <div className="text-[10px] font-semibold text-gray-400 uppercase mb-2">
        {group.title}
      </div>
      <div className="flex flex-col gap-2">
        {group.items.map((item) => (
          <div
            key={item.type + item.label}
            className={`${draggable ? 'cursor-grab' : 'cursor-pointer active:scale-[0.98]'} rounded-lg border border-white/10 bg-black/70 px-3 py-2 text-[11px] text-gray-100 flex items-center justify-between hover:border-purple-400 transition-all`}
            draggable={draggable}
            onDragStart={draggable ? (e) => onDragStartPalette(e, item.type) : undefined}
            onClick={!draggable ? () => onAddBlock?.(item.type) : undefined}
            title={draggable ? 'Arraste para o fluxo' : 'Toque para adicionar ao fluxo'}
          >
            <div className="flex items-center gap-2">
              <span
                className={`inline-flex h-6 w-6 items-center justify-center rounded-full ${item.color} text-black text-[10px]`}
              >
                {typeof item.icon === 'string' ? <i className={item.icon} /> : item.icon}
              </span>
              <div>
                <div className="font-semibold leading-tight">{item.label}</div>
                {item.description && (
                  <div className="text-[9px] text-gray-400">{item.description}</div>
                )}
              </div>
            </div>
            <i className={`fas ${draggable ? 'fa-grip-vertical' : 'fa-plus'} text-gray-500`} />
          </div>
        ))}
      </div>
    </div>
  ));
}

export default function FlowSidebar({ onDragStartPalette, onAddBlock }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      {/* Desktop: sidebar fixa com arrastar-e-soltar */}
      <div className="hidden md:flex w-64 border border-white/10 rounded-lg bg-black/60 p-3 flex-col gap-3 overflow-y-auto">
        <div className="text-[11px] font-semibold text-gray-200 uppercase tracking-wide">
          Blocos disponíveis
        </div>
        <BlockGroups draggable onDragStartPalette={onDragStartPalette} />
      </div>

      {/* Mobile: hambúrguer que abre drawer; toque adiciona o bloco direto */}
      <div className="md:hidden flex-shrink-0">
        <button
          type="button"
          className="w-full flex items-center justify-between px-3 py-2 border border-white/10 rounded-lg bg-black/60 text-[11px] font-semibold text-gray-200 uppercase tracking-wide"
          onClick={() => setMobileOpen(true)}
        >
          <span className="flex items-center gap-2">
            <i className="fas fa-bars" /> Blocos disponíveis
          </span>
          <i className="fas fa-plus text-gray-400" />
        </button>

        {mobileOpen && (
          <div className="fixed inset-0 z-50">
            <div
              className="absolute inset-0 bg-black/60"
              onClick={() => setMobileOpen(false)}
            />
            <div className="absolute right-0 top-0 h-full w-72 max-w-[85vw] bg-[#0b0f1a] border-l border-white/10 p-3 flex flex-col gap-2 overflow-y-auto">
              <div className="flex items-center justify-between">
                <span className="text-[11px] font-semibold text-gray-200 uppercase tracking-wide">
                  Blocos disponíveis
                </span>
                <button
                  type="button"
                  className="h-8 w-8 rounded-lg text-gray-400 hover:text-white"
                  title="Fechar"
                  onClick={() => setMobileOpen(false)}
                >
                  <i className="fas fa-xmark" />
                </button>
              </div>
              <div className="text-[10px] text-gray-400">
                Toque num bloco para adicioná-lo ao fluxo — eles são empilhados um abaixo do outro.
              </div>
              <BlockGroups draggable={false} onAddBlock={onAddBlock} />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
